import { ContextType } from '@generated/graphql'

const getFieldsInheritedFromGlobalTemplate = ({ globalTemplate }) =>
  globalTemplate?.fields?.filter(
    field =>
      field.context === ContextType.Global ||
      field.context === ContextType.Company,
  ) || []

const mergeTemplateWithGlobalFields = ({ template, globalTemplate }) => {
  if (!template || !template.network || !globalTemplate) {
    return template
  }

  const inheritedFields = getFieldsInheritedFromGlobalTemplate({
    globalTemplate,
  })
  const templateFieldKeys = new Set(template.fields.map(field => field.key))

  return {
    ...template,
    fields: [
      ...inheritedFields.filter(field => !templateFieldKeys.has(field.key)),
      ...template.fields,
    ],
  }
}

export const getTemplateByTypeAndSubtype = ({
  templates,
  type,
  subtype,
  currentNetworkId,
}: {
  templates: any[]
  type: string
  subtype: string
  currentNetworkId: string
}) => {
  const template =
    subtype !== undefined
      ? templates.find(
          template =>
            template.type === type &&
            template.subtype === subtype &&
            (currentNetworkId
              ? template.network?.id === currentNetworkId
              : !template.network),
        )
      : templates.find(
          template =>
            template.type === type &&
            (currentNetworkId
              ? template.network?.id === currentNetworkId
              : !template.network),
        )

  const globalTemplate = templates.find(
    template =>
      template.type === type &&
      template.subtype === subtype &&
      !template.network,
  )

  return mergeTemplateWithGlobalFields({ template, globalTemplate })
}
